import React from 'react';
import { Link } from 'react-router-dom';
import { Download } from 'react-bootstrap-icons';
// import { Linkedin } from 'react-bootstrap-icons';0
import socLogo from '../assets/soc-logo.webp';
import isoLogo from '../assets/iso-logo-white.webp';
import logo from '../assets/tms-logo.webp';
import LinkedinLogo from '../assets/LinkedIn-logo.webp';

const Footer = () => {
    return (
        <footer className="w-full bg-[#090E1B] text-[#090E1B] py-6">
            <div className="site-shell flex flex-col gap-6 mb-10">

                {/* Top Section: Logo + Nav Links + LinkedIn Button */}
                <div className="flex flex-col lg:flex-row justify-between items-center gap-6">

                    {/* Left: TMS Logo */}
                    <div className="flex-shrink-0">
                        <img src={logo} alt="TMS" className="h-8 w-auto object-contain" />
                    </div>

                    {/* Center: Navigation Links */}
                    <nav className="flex flex-wrap justify-center gap-6 md:gap-16">
                        <Link to="/" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">Home</Link>
                        <Link to="/features" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">Features</Link>
                        <Link to="/how-it-works" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">How it works</Link>
                        <Link to="/security" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">Security</Link>
                        <Link to="/about-us" className="font-inter font-normal text-[14px] text-[#FFFFFF] hover:text-[#00C2FF] transition-colors">About Us</Link>
                    </nav>
                </div>

                {/* Divider */}
                <div className="h-[1px] bg-gray-700 w-full"></div>

                {/* Bottom Section: ISO/SOC Logos + Buttons — always one row */}
                <div className="flex flex-row justify-between items-center gap-3">

                    {/* Left Side: ISO & SOC Logos — flex-shrink-0 so they never squeeze */}
                    <div className="flex items-center gap-3 flex-shrink-0">
                        <img src={socLogo} alt="SOC Certified" className="h-12 w-auto flex-shrink-0" loading="lazy" />
                        <img src={isoLogo} alt="ISO Certified" className="h-12 w-auto flex-shrink-0" loading="lazy" />
                    </div>

                    {/* Right Side: Brochure (always full) + LinkedIn (icon-only on small, full text on md+) */}
                    <div className="flex flex-row items-center gap-3 flex-shrink-0">
                        {/* Brochure — always shows icon + text */}
                        <Link
                            to="/brochure"
                            className="flex items-center gap-2 bg-white hover:bg-gray-100 text-[#090E1B] font-inter font-normal text-[16px] px-6 py-2 rounded-[4px] transition-colors whitespace-nowrap"
                        >
                            <Download size={18} className="flex-shrink-0" />
                            Brochure
                        </Link>

                        {/* LinkedIn — icon-only square on small screens, full text on md+ */}
                        <Link
                            to="https://www.linkedin.com/company/fintechglobalcenter/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center justify-center gap-2 bg-[#0A66C2] hover:bg-[#084d94] text-white font-inter font-semibold text-[16px] rounded-[4px] transition-colors
                                       p-2 md:px-6 md:py-2"
                        >
                            <img src={LinkedinLogo} alt="LinkedIn" className="h-5 w-5 flex-shrink-0" />
                            <span className="hidden md:inline whitespace-nowrap">Follow us on LinkedIn</span>
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
